import styled from 'styled-components'

export const Header = styled.header`
  font-family: ${(props) => props.theme.font_family};
  position: relative;
  z-index: 61;
  line-height: normal;
  -webkit-font-smoothing: antialiased;

  a {
    text-decoration: none;
    color: inherit;
  }
`

export const Main = styled.div`
  border-bottom: 1px solid ${(props) => props.theme.color_grey_mid};
  width: 100%;
  padding: 10px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;

  @media (min-width: ${(props) => props.theme.screen_lg_min}) {
    padding: 16px;
  }
`

export const TopBar = styled.div`
  display: flex;
  background: ${(props) => props.theme.color_grey_light};
  color: ${(props) => props.theme.color_grey_darker};
  height: 30px;
  justify-content: flex-end;
  align-items: center;
  padding-right: 15px;
  padding-left: 15px;
  padding-bottom: 1px;
  max-width: 1920px;
  margin-right: auto;
  margin-left: auto;
`

export const TopLink = styled.a`
  display: flex;
  align-items: center;
  color: inherit;

  svg {
    margin-top: 2px;
    fill: currentColor;
  }

  span {
    padding-left: 10px;
  }

  :hover {
    color: ${(props) => props.theme.color_primary};
    transition: all 0.15s ease-in-out;
  }

  :not(:first-child) {
    position: relative;
    padding-left: 15px;
    margin-left: 15px;

    ::before {
      content: '';
      position: absolute;
      width: 1px;
      height: 15px;
      background-color: #ccc;
      left: 0;
      top: 50%;
      margin-top: -8px;
    }
  }
`

export const LogoContainer = styled.div`
  flex-grow: 1;

  @media (min-width: ${(props) => props.theme.screen_lg_min}) {
    flex-grow: 0;
    margin-right: 30px;
  }
`

export const LogoLink = styled.a`
  display: block;
  width: 49px;
  height: 39px;

  @media (min-width: ${(props) => props.theme.screen_lg_min}) {
    width: 60px;
    height: 51px;
  }

  @media (min-width: ${(props) => props.theme.screen_lg_max}) {
    width: 70px;
    height: 60px;
  }

  img {
    max-width: 100%;
  }
`

export const ShopLink = styled.a`
  display: none;
  align-items: center;
  align-self: stretch;
  padding: 0 10px;

  @media (min-width: ${(props) => props.theme.screen_lg_min}) {
    display: flex;
  }
`

export const Search = styled.div`
  flex-grow: 1;
  order: 3;
  width: 100%;
  margin-top: 10px;

  @media (min-width: ${(props) => props.theme.screen_lg_min}) {
    margin-left: 45px;
    margin-right: 60px;
    margin-top: 0;
    width: auto;
  }
`

export const Icons = styled.div`
  display: flex;

  @media (min-width: ${(props) => props.theme.screen_lg_min}) {
    order: 3;
  }
`

export const IconLink = styled.a`
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 61px;
  height: 48px;
  color: inherit;

  :hover {
    color: ${(props) => props.theme.color_primary};
    transition: all 0.15s ease-in-out;
  }

  svg {
    width: 20px;
    height: 20px;
    fill: currentColor;
  }

  span {
    font-size: 14px;
    padding-top: 6px;
  }

  @media (min-width: ${(props) => props.theme.screen_lg_min}) {
    width: 71px;

    :first-of-type {
      display: none;
    }

    span {
      font-size: 15px;
    }

    svg {
      width: 24px;
      height: 24px;
    }
  }
`
